import React from "react";
import { motion } from "framer-motion";
import { Save } from "lucide-react";

interface SaveButtonProps {
  id?: string;
  onClick: () => void;
  isSaving: boolean;
  disabled?: boolean;
  text: string;
  className?: string;
}

const SaveButton: React.FC<SaveButtonProps> = ({
  id,
  onClick,
  isSaving,
  disabled,
  text,
  className = "",
}) => {
  const isDisabled = isSaving || disabled;

  return (
    <motion.button
      id={id}
      whileHover={isDisabled ? {} : { scale: 1.02 }}
      whileTap={isDisabled ? {} : { scale: 0.98 }}
      onClick={onClick}
      disabled={isDisabled}
      className={`flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm transition-all shadow-md hover:shadow-lg ${
        isDisabled
          ? "bg-slate-100 text-slate-400 border border-slate-200 cursor-not-allowed shadow-none hover:shadow-none"
          : "bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-500 hover:to-emerald-500 shadow-green-500/20"
      } ${className}`}
    >
      {isSaving ? (
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin flex-shrink-0" />
      ) : (
        <Save className="h-4 w-4 flex-shrink-0" />
      )}
      <span className="whitespace-nowrap">{text}</span>
    </motion.button>
  );
};

export default SaveButton;



